import {PapayaColorTable} from '../../dashboard-papaya/symbols/dashboard-papaya-color-table.symbols';

/**
 * Get papaya color table.
 * Uses papaya function to get the color table.
 * It makes the image grayscale.
 * Used for the base images, so the labeled regions will be colored over them.
 */
export function getOriginalPapayaColorTableGrayscale(): PapayaColorTable {
  // @ts-ignore
  return new papaya.viewer.ColorTable('Grayscale', true);
}
